var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"module-lesson-loader module-lesson-content"},[_c('div',{staticClass:"content"},[_c(_setup.LessonLoader)],1),(_setup.isDesktopDevice)?_c('div',{staticClass:"sideshow"},[_c(_setup.ModuleSelectorLoader)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }